export function removeChildElements(parentElement) {
    if (parentElement) {
        while (parentElement.firstChild) {
            parentElement.removeChild(parentElement.firstChild);
        }
    } else {
        console.error('In function removeChildElements parent element not found');
    }
}
